import React from "react";

const Loader = () => {
  return (
    <div className="h-[100vh] flex items-center justify-center">
      <div className="loader w-14 h-14 mx-auto relative"></div>
    </div>
  );
};

export default Loader;
